module.exports = __webpack_public_path__ + "icomoon.svg?522f444447baf956e6158e0d4a2fc31d";